/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import { googleEvents } from '../../../../utils/googleEvents';
import { waitForConsentPresent } from '../../../../analytics/core';

const $ = window.$;

export default class PromoLabel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAnalyticsFired: false
        };
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    static propTypes = {
        product: PropTypes.object,
        placement: PropTypes.string,
    };

    static defaultProps = {
        placement: 'top',
    };

    handleAnalytics() {
        const { analyticsData } = this.props;
        
        if (analyticsData && !this.state.isAnalyticsFired) {
            this.setState({
                isAnalyticsFired: true
            }, () => waitForConsentPresent(() => googleEvents.viewProductPromotion(analyticsData)));
        }
    }

    setRef = (ref) => (ref ? (this.selfRef = ref) : null);

    componentDidMount() {
        if (!this.props.product) {
            return null;
        }

        const { shortPromoText, longPromoText, placement } = this.props.product;

        if (!shortPromoText && !longPromoText) {
            return null;
        }

        $(this.selfRef).popover({
            trigger: 'focus',
            container: 'body',
            placement: placement,
            title: shortPromoText,
            content: longPromoText,
        });

        this.handleAnalytics();
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.handleAnalytics();
        }
    }

    componentWillUnmount() {
        $(this.selfRef).popover('hide');
    }

    render() {
        const { product, className } = this.props;

        if (!product) {
            return null;
        }

        const { promoCode } = product;

        if (!promoCode) {
            return null;
        }

        return (
            <a
                href={'#'}
                onClick={(e) => {
                    e.preventDefault();
                }}
                ref={this.setRef}
                className={'promo-label' + (className ? ' ' + className : '')}
            >
                {promoCode}
            </a>
        );
    }
}
